import Footer from "./components/Footer";
import Routes from "./routes";
import { Container } from "./styles";

function App() {
  return (
    <Container>
      <div className="login__header">
        <div className="login__logo-container">
          <a href="https://www.zonasul.com.br">
            <img className="login__logo" src="https://zonasul.vtexassets.com/arquivos/logo_zonasul.svg?v=1" alt="Logo do Supermercado Zonasul" />
          </a>
        </div>
      </div>

      <div className="login__area">
        <Routes />
      </div>

      <Footer />
    </Container>
  );
}

export default App;
